import React from 'react'
import ReactGA from 'react-ga'

import {Helmet} from "react-helmet"
import { Provider } from 'react-redux'
import configureStore from '~/configureStore'
import { renderRoutes } from 'react-router-config'
import routes from '~/routes'
// import ModalSwitch from '~/app/components/ModalSwitch'
import Menu from '~/menu/components/Menu'
import ZedPlayer from '~/player/components/ZedPlayer'
import ErrorBoundary from './ErrorBoundary'
import {
  Route,
  withRouter
} from 'react-router-dom'

// A simple component that shows the pathname of the current location
class ShowTheLocation extends React.Component {
  render() {
    const { match, location, history } = this.props
    if (typeof(window) !== "undefined") {
      ReactGA.pageview(location.pathname)
    }
    return (
      null
    )
  }
}


// Create a new component that is "connected" (to borrow redux
// terminology) to the router.
const ShowTheLocationWithRouter = withRouter(ShowTheLocation)



const App = () => (
    <div>
      <Helmet>
        <title>4ZZZ - Community Radio Brisbane</title>
        <meta name="description" content="4ZZZ Community Radio Brisbane" />
        <meta name="og:description" content="4ZZZ Community Radio Brisbane" />
				<meta name="og:image" content="https://4zzz.org.au/assets/4zzz-1021-boat.jpg" />
        <meta name="twitter:card" content="summary_large_image"/>
        <meta name="twitter:site" content="@4zzzradio" />
      </Helmet>
      <Menu />
      <ShowTheLocationWithRouter />
      <ErrorBoundary>
				<div className="routes">
	        {/*<Route component={ModalSwitch} />*/}
	        {renderRoutes(routes)}
	      </div>
			</ErrorBoundary>
      <ZedPlayer />
    </div>
)

export default App;
